import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { CARD_SERVICE } from '../EndPoints';

// create resource /resource/create card-module card-controller
export const CreateResourceApi = createAsyncThunk('cards/createResourceApi', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .post(CARD_SERVICE.createResourceApi, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// create single card /v1/create card-module card-controller
export const CreateSingleCard = createAsyncThunk('cards/createSingleCard', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .post(CARD_SERVICE.createSingleCard, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// create multiple cards /v1/create-all card-module card-controller
export const CreateMultipleCards = createAsyncThunk(
    'cards/createMultipleCards',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(CARD_SERVICE.createMultipleCards, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// analize cards /v1/analize-cards card-module card-controller
export const AnalizeCards = createAsyncThunk('cards/analizeCards', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .post(CARD_SERVICE.analizeCards, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// get all card formats /type/get-all card-module card-controller
export const GetAllCardFormats = createAsyncThunk('cards/getAllCardFormats', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .get(CARD_SERVICE.getAllCardFormats)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// get preview by id /type/get-all card-module card-controller
export const GetPreview = createAsyncThunk('cards/getPreview', async (id, { dispatch, getState }) => {
    const result = await apiInstance
        .get(`${CARD_SERVICE.getPreview}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// Assign Card To User /v1/user/assign-card card-module card-controller
export const AssignCardToUser = createAsyncThunk('cards/assignCardToUser', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put(CARD_SERVICE.assignCardToUser, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// Remove Card To User /v1/user/remove-card card-module card-controller
export const RemoveCardToUser = createAsyncThunk('cards/removeCardToUser', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put(CARD_SERVICE.removeCardToUser, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const CreateTemplateCard = createAsyncThunk(
    'cards/createTemplateCard',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(CARD_SERVICE.createTemplateCard, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateTemplateCard = createAsyncThunk(
    'cards/updateTemplateCard',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(CARD_SERVICE.updateTemplateCard, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AssignTemplateToCards = createAsyncThunk(
    'cards/assignTemplateToCards',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .put(CARD_SERVICE.assignTemplateToCards, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status, code } = result;

        return { data, status, code };
    },
);

export const RemoveTemplates = createAsyncThunk('cards/removeTemplates',async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .put(CARD_SERVICE.removeTemplates, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status, code } = result;

        return { data, status, code };
    },
);
